export default __webpack_public_path__ + "static/media/tutorial-2.146a026c.svg";